import { createPinia, Pinia } from 'pinia'

let piniaInstance: Pinia | null = null

export function createCongressPinia(options = {}): Pinia {
  if (!piniaInstance) {
    piniaInstance = createPinia()
  }

  piniaInstance.use(({ store }: any) => {
    Object.assign(store, options)
  })
  return piniaInstance
}
